import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5ce9afdc&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=5ce9afdc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce9afdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ce9afdc')) {
      api.createRecord('5ce9afdc', component.options)
    } else {
      api.reload('5ce9afdc', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=5ce9afdc&scoped=true", function () {
      api.rerender('5ce9afdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/inquiry/transaction/Index.vue"
export default component.exports